import React, {useState} from "react";
import {useTimeseriesIncidentsQuery} from "./query";
import IncidentsGraphsBase from "./IncidentGraphsBase";


const IncidentsGraphs = () => {
    const [filters, setFilters] = useState({region_id: undefined, province_id: undefined});

    const selectedProvinceId = filters.province_id;
    const selectedRegionId = filters.region_id;

    const setSelectedRegionId = (regionId) => {
        setFilters((prev) => ({...prev, region_id: regionId, province_id: undefined}));
    }

    const setSelectedProvinceId = (provinceId) => {
        setFilters((prev) => ({...prev, province_id: provinceId}));
    }

    const timeseriesQuery = useTimeseriesIncidentsQuery({filters} );

    return <IncidentsGraphsBase timeseriesQuery={timeseriesQuery}
                                regionId={selectedRegionId}
                                provinceId={selectedProvinceId}
                                setSelectedRegionId={setSelectedRegionId}
                                setSelectedProvinceId={setSelectedProvinceId}/>;
}


export default IncidentsGraphs;